import { Box, Display, Paragraph } from '@rover/kibble/core';

import { TabletAndDownButton } from '../layouts';

export type Props = {
  onLearnMore: () => void;
  isDesktop?: boolean;
};

function MarketingContextHeader({ onLearnMore, isDesktop }: Props): JSX.Element {
  // DEV-104195: Translate all strings below
  return (
    <Box
      background="primary"
      pt="10x"
      pb={isDesktop ? '3x' : '6x'}
      px="4x"
      width="100%"
      mb={['0x', '2x']}
    >
      <Display webProps={{ responsive: false, as: 'h2' }} size="400" mb="3x">
        Dog Training on Rover
      </Display>
      <Paragraph size="300" mb="0x">
        Professional dog trainers on a platform you trust.{' '}
        <TabletAndDownButton
          p="0x"
          size="large"
          variant="flat"
          sx={{ textDecoration: 'underline' }}
          onClick={onLearnMore}
        >
          Learn more
        </TabletAndDownButton>
      </Paragraph>
    </Box>
  );
}

export default MarketingContextHeader;
